module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("col-xs-12 profile-card " + _vm.layoutStyle)
  }, [_c('el-card', {
    attrs: {
      "body-style": {
        padding: '0px'
      },
      "shadow": "hover"
    }
  }, [_c('div', {
    attrs: {
      "id": "grid-image-container"
    }
  }, [_c('el-image', {
    staticClass: "grid-image",
    attrs: {
      "fit": "'cover'",
      "lazy": "",
      "src": _vm.profile.image ? _vm.profile.image : _vm.identicon
    },
    on: {
      "error": _vm.imageLoadError
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "placeholder"
    },
    slot: "placeholder"
  }, [_c('img', {
    attrs: {
      "width": "120",
      "height": "120",
      "src": _vm.identicon
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-card-content"
  }, [_c('div', {
    staticClass: "top-content"
  }, [(_vm.profile.name) ? _c('div', {
    staticClass: "profile-name"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.profile.name,
      "placement": "bottom"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.profile.name))])])], 1) : _c('div', {
    staticClass: "profile-name"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.profile.identifier,
      "placement": "bottom"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.profile.identifier))])])], 1), _vm._v(" "), (_vm.profile.name) ? _c('div', {
    staticClass: "profile-identifier"
  }, [_vm._v(_vm._s(_vm.profile.identifier))]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8914ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/profile/GridCard.vue
// module id = 3415
// module chunks = 3